import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import 'animate.css/animate.min.css';
import '../css/bubbles.scss';

class Bubbles extends Component {

  render() {
    const stylesBubble1 = {
        marginLeft: "20%"
    };
    const stylesBubble2 = {
      marginLeft: "40%"
    };
    const stylesBubble3 = {
      marginLeft: "60%"
    };
    const stylesBubble4 = {
      marginLeft: "80%"
    };

    const parentStyles = {
      display: this.props.visible ? "block":"none"
    };

    return (
        <div style={parentStyles}>
          <span className="bubble bubble1" style={stylesBubble1}></span>
          <span className="bubble bubble2" style={stylesBubble2}></span>
          <span className="bubble bubble3" style={stylesBubble3}></span>
          <span className="bubble bubble4" style={stylesBubble4}></span>
        </div>
    );
  }
}

export default Bubbles;


// WEBPACK FOOTER //
// ../components/Bubbles.js